import { Field } from '../../../../settings/types/field';

export const getProspectCustomAttributes = (fields: Field[]) => {
  const customAttributes = [];

  fields?.forEach((field) => {
    if (!field?.isDefault) {
      customAttributes?.push({
        id: field?.id?.toString(),
        label: field?.label,
        fieldType: field?.fieldType,
        isEditable: true,
        fieldMetadata: field?.fieldMetadata,
      });
    }
  });

  return customAttributes;
};
